// extracted by mini-css-extract-plugin
export default {"cta":"bank_cta__lS9kV","button":"bank_button__kkcz1","bold":"bank_bold__fx1Si"};